<script>
	import { Tabs, TabList, TabPanel, Tab } from "../components/tabs/tabs";
	import AmenitiesBox from '../components/AmenitiesBox.svelte';
	
	let amenitiesdata = [
		{
			name: "SWIMMING POOL",
			icon: "SwimmingPool.jpg",
            type: "pool",
            description: ""
		},
		{
			name: "ROOM SERVICE",
            type: "normal",
			icon: "Room-Service.jpg",
			description: "Room service enabling our guests to choose cocktails or delicious menu items for delivery to their cottages at your convenience."
		},
		{
			name: "WIFI",
            type: "normal",
			icon: "wifi.jpg",
            description: "We strongly recommend to leave behind the online world once you enter our resort to enjoy the nature in the best way. <br />Unless you have an important requirement to go online , then you can connect to the solar powered eco wifi in the rooms or restaurant or anywhere in the resort premises."
		},
		{
			name: "LAUNDRY",
            type: "normal",
			icon: "Laundry.jpg",
            description: "With in-house professional laundry machines, all our linen are washed with 80 degree solar heated water considering climate change and hygiene. The greywater is treated and recycled for gardening, therefore reducing the fresh water usage."
		},
		{
			name: "MIST DANCE",
            type: "normal",
            icon: "mist-dance.jpg",
			description: "Dancing in a mist filled floor one of a unique experience, with great mix of tunes by our in house DJ."
		},
		{
			name: "SPORTS",
            type: "normal",
			icon: "Sports.jpg",
			description: "With concrete blocks taking over our city playing grounds , we have been restricted to only watch on television. A two acre ground for outdoor sports to play : Cricket , Football , Basket ball , Volley ball , Tug-of-war , Badminton  and others. <br /> Indoor Games : Table Tennis  , Foosball table , Board games"
		}
	]
</script>

<div class="image-background">
    <h1 class="header_text_wrapper text-left">
        <span>Amenities</span><span class="separator"></span>
    </h1>
</div>
<div class="primary">
    <div class="container-fluid">
        {#each amenitiesdata as item}
            <AmenitiesBox name={item.name} icon={item.icon} type={item.type} description={item.description} />
        {/each}
    </div>
</div>

<style>
    .image-background {
        background: url("../images/Day-Out-1.jpg") no-repeat center;
    }

	.primary {
		background: rgba(0, 0, 0, 0) url("../images/gpattern-opacity-1.png") repeat scroll 0 0;
	}
</style>